import api from './api';

// Event, mit dem die Sidebar nach einer Änderung neu lädt
export const MENUE_UPDATED_EVENT = 'menue-sichtbarkeit-updated';

export const menueService = {
  getSichtbarkeit: async (): Promise<Record<string, boolean>> =>
    (await api.get('/menue-sichtbarkeit')).data,

  setSichtbarkeit: async (sektion: string, sichtbar: boolean): Promise<void> => {
    await api.put(`/menue-sichtbarkeit/${sektion}`, { sichtbar });
    window.dispatchEvent(new Event(MENUE_UPDATED_EVENT));
  },
};

export default menueService;
